/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Memberships. List of memberships.
 */
export interface MembershipParam { 
    /**
     * Id Hash. UUI (Unique User Identifier). Mandatory in the POST and PUT CompanyServices, Optional in the GET CompanyServices. Must not be specified in the POST, PUT and GET UserServices.
     */
    userIdHash?: string;
    /**
     * Id Hash. UCI (Unique Company Identifier). Mandatory in the POST and PUT UserServices, Optional in the GET UserServices. Must not be specified in the POST, PUT and GET CompanyServices.
     */
    companyIdHash?: string;
    /**
     * Company department name.
     */
    companyDepartmentName?: string;
    /**
     * Date Not Before. Format yyyy-MM-dd HH:mm:ss
     */
    notBefore?: string;
    /**
     * Date Not After. Format yyyy-MM-dd HH:mm:ss
     */
    notAfter?: string;
    /**
     * User role in this company. Maximum lenght 25
     */
    role?: string;
    /**
     * User membership number in this company. Maximum lenght 50
     */
    membershipNumber?: string;
    /**
     * User membership type in this company. Maximum lenght 50
     */
    membershipType?: string;
    /**
     * User membership QR or Barcode in this company, it\'s an image, encoded in Base64 format. Maximum lenght 2MB
     */
    membershipQR?: MembershipParam.MembershipQREnum;
    /**
     * Additional information that some types of memberships may require. Example: in the case of a minor’s hunting license, this field should contain the identifier of the accompanying adult’s hunting license (for example: \'TD012345F-903245\'). Maximum lenght 255
     */
    additionalInformation?: string;
}
export namespace MembershipParam {
    export const MembershipQREnum = {
        B4a14c44f: '[B@4a14c44f'
    } as const;
    export type MembershipQREnum = typeof MembershipQREnum[keyof typeof MembershipQREnum];
}


